import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast, Bounce } from "react-toastify";
import SellerRegisPageHeader from "../../components/SellerRegisterPageHeader";
import SellerRegisPageBlock1 from "../../components/SellerRegisterPageBlock1";
import SellerRegisPageBlock2 from "../../components/SellerRegisterPageBlock2";
import SellerRegisPageBlock3 from "../../components/SellerRegisterPageBlock3";
import SellerRegisPageBlock4 from "../../components/SellerRegisterPageBlock4";
import HomePageFooter from "../../components/HomePageFooter";

import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./sellerregispage.module.css";
import { useCookies } from "react-cookie";
import { SellerRegister } from "../../apis/sellerregister";
import { dataURLtoFile } from "../../utils/formData";

const SellerRegisterPage = () => {
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const userId = cookies["user_info"].id;

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const updateData = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
    console.log(formData);
  };

  const saveFormData = async () => {
    let sellerProfile = new FormData();
    sellerProfile.append("ShopName", formData.shopName);
    sellerProfile.append(
      "PickupAddressFullName",
      formData.addressInfo.fullName
    );
    sellerProfile.append("PickupAddressPhone", formData.addressInfo.phone);
    sellerProfile.append(
      "PickupAddressAddress",
      `${formData.addressInfo.address}, ${formData.addressInfo.plusAddress}`
    );
    sellerProfile.append("BusinessType", formData.businessType);
    sellerProfile.append(
      "RegisteredBusinessAddress",
      `${formData.selectedWardName}, ${formData.selectedDistrictName}, ${formData.selectedCityName}`
    );
    sellerProfile.append("EmailToReceiveElectronicInvoices", formData.emailE);
    sellerProfile.append("TaxCode", formData.taxCode);
    sellerProfile.append("Email", formData.email);
    sellerProfile.append("Phone", formData.phone);
    sellerProfile.append("IdentificationCardId", formData.cccdNumber);
    sellerProfile.append("FullName", formData.fullName);
    sellerProfile.append(
      "FrontImage",
      dataURLtoFile(
        formData.frontCCCD,
        `frontCCCD-${formData.shopName}-${formData.cccdNumber}.png`
      )
    );
    sellerProfile.append(
      "BackImage",
      dataURLtoFile(
        formData.backCCCD,
        `backCCCD-${formData.shopName}-${formData.cccdNumber}.png`
      )
    );
    sellerProfile.append(
      "SignatureImage",
      dataURLtoFile(
        formData.signatureImage,
        `signatureImage-${formData.shopName}-${formData.cccdNumber}.png`
      )
    );
    sellerProfile.append("UserId", userId);

    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await SellerRegister(
          sellerProfile,
          cookies["access_token"]
        );
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return t("submitting");
          },
        },
        success: {
          render({ result }) {
            console.log(result);
            return t("seller_regis_success");
          },
        },
        error: {
          render({ result }) {
            return `${t("error_occurred")}: ${
              result.response?.result?.message || result.message
            }`;
          },
        },
      }
    );
  };

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <SellerRegisPageHeader />
      <div className={`${styles.container}`}>
        <ul className={styles.steps}>
          <li
            className={`${styles.step} ${
              currentStep === 1 ? styles.active : ""
            }`}
          >
            {t("shop_infor")}
          </li>
          <li
            className={`${styles.step} ${
              currentStep === 2 ? styles.active : ""
            }`}
          >
            {t("tax_infor")}
          </li>
          <li
            className={`${styles.step} ${
              currentStep === 3 ? styles.active : ""
            }`}
          >
            {t("indentification_infor")}
          </li>
          <li
            className={`${styles.step} ${
              currentStep === 4 ? styles.active : ""
            }`}
          >
            {t("contract_confirm")}
          </li>
        </ul>
        {currentStep === 1 && (
          <SellerRegisPageBlock1
            onNext={handleNextStep}
            updateData={updateData}
            formData={formData}
          />
        )}
        {currentStep === 2 && (
          <SellerRegisPageBlock2
            onBack={handlePreviousStep}
            onNext={handleNextStep}
            updateData={updateData}
            formData={formData}
          />
        )}
        {currentStep === 3 && (
          <SellerRegisPageBlock3
            onBack={handlePreviousStep}
            onNext={handleNextStep}
            updateData={updateData}
            formData={formData}
          />
        )}
        {currentStep === 4 && (
          <SellerRegisPageBlock4
            onBack={handlePreviousStep}
            onNext={saveFormData}
            updateData={updateData}
            formData={formData}
          />
        )}
      </div>
      <HomePageFooter />
    </div>
  );
};

export default SellerRegisterPage;
